// extracted by mini-css-extract-plugin
export default {"clickingOverviewContainer":"StepsAsymmetry_clickingOverviewContainer__uw+kg","chartHeader":"StepsAsymmetry_chartHeader__ECYbU"};